// This is just an example,
// so you can safely delete all default props below

export default {
    previous_step: 'Tilbake',
    next_step: 'Neste steg',
    outward_trips: 'Utreise',
    backward_trips: 'Retur',
    go_home: 'Gå til startsiden',
    payment_option_desc: 'Valg av betalings- / reservasjons produkt velges på neste side',
    error_outward_trip: 'Utreise må velges',
    error_backward_trip: 'Retur må velges',
    error_trips_relation: 'NB! Retur reisen må starte etter utreisen.',
    time_passed_title:'Bestillingstidspunktet er nå passert',
    time_passed_content:'Muligheten for å bestille ønsket reise er stoppet pga bestillingstidspunktet er passert for en av valgene. Velg OK for å gå tilbake til hovedsiden for nytt reisesøk.',
    general_error_title: 'Rundtur støttes ikke på valgt reise',
    general_error_content: 'Det er ikke mulig å kjøpe denne reisen som én sammenhengende rundtur/billett av tekniske årsaker. Men du kan kjøpe denne reisen som to adskilte enkeltreiser/billetter.'
}
